








































import { Component, Vue } from 'vue-property-decorator'
import {
  GradeFrameController,
  FeatureController,
  AgencyController,
  SchoolController,
} from '@/services/request.service'
import SchoolEditor from './components/SchoolEditor.vue'
import FeatureEditor from './components/FeatureEditor.vue'
import FrameEditor from './components/FrameEditor.vue'
import { getAgencyId } from '@/utils/utils'

Component.registerHooks(['beforeRouteLeave'])

@Component({
  components: {
    SchoolEditor,
    FeatureEditor,
    FrameEditor,
  },
})
export default class AddSchool extends Vue {
  private school: any = {
    name: '',
    shortName: '',
    introduction: '',
    address: '',
    tel: '',
    type: undefined,
    sectionIds: [],
    email: '',
    memberName: '',
    memberEnName: '',
    openSchoolYear: undefined,
  }
  private selectedFeatures = ['GROTHMNT', 'NOTIFICA']
  private frame: any = {
    frameId: undefined,
  }
  private features: Array<any> = []
  private saved = false
  private result = false

  private created(): void {
    this.$route.meta.refresh = false
    this.getFeatures()
  }

  private beforeRouteLeave(to, from, next): void {
    if (!this.$store.state.forceBack) {
      if (!this.saved) {
        this.$confirm({
          title: this.$tc('common.reserveEdit'),
          onOk: () => {
            next()
          },
          onCancel: () => {
            next(false)
          },
        })
      } else {
        next()
      }
    } else {
      next()
    }
  }

  private getFeatures(): void {
    FeatureController.getFeatures()
      .then(res => {
        this.features = res.data
      })
      .catch(err => {
        console.error(err)
      })
  }

  private complete(): void {
    let featureIds = [] as Array<number>
    this.features.forEach(feature => {
      if (this.selectedFeatures.includes(feature.featureCode)) {
        featureIds.push(feature.featureId)
      }
    })
    const {
      name,
      shortName,
      introduction,
      address,
      tel,
      type,
      sectionIds,
      email,
      memberName,
      memberEnName,
      openSchoolYear,
    } = this.school
    const gradeFrameId = this.frame.frameId
    const agencyId = parseInt(getAgencyId(), 10)
    const request = {
      schoolId: undefined,
      name,
      shortName,
      introduction,
      address,
      tel,
      type,
      sectionIds,
      memberId: undefined,
      email,
      memberName,
      memberEnName,
      openSchoolYear,
      featureIds,
      gradeFrameId,
      agencyId,
    }
    const schoolEditorForm = this.$refs.schoolEditor as any
    schoolEditorForm.$refs.schoolEditor.validate(valid => {
      if (valid) {
        if (this.selectedFeatures.includes('ASSSHEET')) {
          const frameEditorForm = this.$refs.frameEditor as any
          frameEditorForm.$refs.frameEditor.validate(valid => {
            if (valid) {
              SchoolController.add(request)
                .then(res => {
                  this.saved = true
                  this.$route.meta.refresh = true
                  this.$message.success(this.$tc('schoolMgmt.addSchoolSuccess'))
                  this.$router.replace({ name: 'schoolMgmt' }).catch(err => {})
                })
                .catch(err => {
                  console.error(err)
                })
            } else {
              return false
            }
          })
        } else {
          SchoolController.add(request)
            .then(res => {
              this.saved = true
              this.$route.meta.refresh = true
              this.$message.success(this.$tc('schoolMgmt.addSchoolSuccess'))
              this.$router.replace({ name: 'schoolMgmt' }).catch(err => {})
            })
            .catch(err => {
              console.error(err)
            })
        }
      } else {
        return false
      }
    })
  }

  private cancel(): void {
    this.$router.replace({ name: 'schoolMgmt' }).catch(err => {})
  }
}
